// Favorites — persistent, per account (market_favorites, own rows only by RLS;
// written only through market_favorite_toggle). One shared copy for every
// card on the page.

import { useEffect, useState } from 'react';
import { fetchFavoriteIds, toggleFavorite } from './marketCatalog';

let ids = null;          // Set<string> | null (not loaded / signed out)
let loadingFor = null;   // user id the current load is for
const listeners = new Set();
const emit = () => listeners.forEach((f) => f());

async function load(userId) {
  if (!userId) { ids = null; loadingFor = null; emit(); return; }
  if (loadingFor === userId) return;
  loadingFor = userId;
  const r = await fetchFavoriteIds();
  if (loadingFor !== userId) return;
  ids = new Set(r.error ? [] : r.ids);
  emit();
}

/** { ids: Set, isFav(id), toggle(id) → Promise<{ok, on}> } — toggle needs a signed-in user. */
export function useFavorites(userId) {
  const [, force] = useState(0);
  useEffect(() => {
    const f = () => force((n) => n + 1);
    listeners.add(f);
    load(userId);
    return () => listeners.delete(f);
  }, [userId]);
  return {
    ids: ids ?? new Set(),
    isFav: (id) => !!ids?.has(id),
    toggle: async (id) => {
      if (!userId) return { ok: false, error: 'not_signed_in' };
      const r = await toggleFavorite(id);
      if (r.ok) { ids = new Set(ids ?? []); if (r.data) ids.add(id); else ids.delete(id); emit(); }
      return { ok: r.ok, on: r.data === true, error: r.error };
    },
  };
}
